// extracted by mini-css-extract-plugin
export default {"form-label":"NameChangeDialog_form-label__CYv+0","formLabel":"NameChangeDialog_form-label__CYv+0"};